import React, { ReactElement, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Email, Home, Person } from '@mui/icons-material';
import { Button } from '@mui/material';

import { logout } from '../helpers/AuthHelpers';

import '../styles/views/ErrorPage.less';

interface Props {
    errHeadline?: string;
    errMessage?: string;
    statusCode?: number;
}

const ErrorPage = ({ errHeadline, errMessage, statusCode }: Props): ReactElement => {
    const navigate = useNavigate();
    const [errorHeadline, setErrorHeadline] = useState<string>(errHeadline ?? '');
    const [errorMessage, setErrorMessage] = useState<string>(errMessage ?? '');

    useEffect(() => {
        if (statusCode) {
            switch (statusCode) {
                case 404:
                    setErrorHeadline('Sorry! Page not found');
                    setErrorMessage('The page you are looking for does not exists.');
                    break;
                case 403:
                    setErrorHeadline('Sorry! Access Denied');
                    setErrorMessage("The page you're trying to access has restricted access.");
                    break;
                case 401:
                    setErrorHeadline('Sorry! Unauthorized');
                    setErrorMessage("You don't have the required access rights.");
                    break;
                default:
                    setErrorHeadline('Sorry! Unknown error');
                    setErrorMessage('Something went wrong. Please contact customer support.');
            }
        }
    }, [statusCode]);

    return (
        <div className="error-container">
            <div className="left-container">
                <div>
                    <strong>{statusCode}</strong>
                </div>
                <div>Error</div>
            </div>
            <div className="right-container">
                <div className="msg-container">
                    <div className="err-headline">
                        <strong>{errorHeadline}</strong>
                    </div>
                    <div>{errorMessage}</div>
                </div>
                <div className="btn-container">
                    {statusCode === 401 ? (
                        <Button variant="contained" onClick={() => logout()} startIcon={<Person />}>
                            Try again
                        </Button>
                    ) : (
                        <Button variant="contained" onClick={() => navigate('/')} startIcon={<Home />}>
                            Go Home
                        </Button>
                    )}
                    <Button variant="outlined" startIcon={<Email />}>
                        <a className="no-style" href="mailto:support@controlant.com">
                            Contact Support
                        </a>
                    </Button>
                </div>
                <div>
                    If the error persists, please contact support. Explain what you where trying to do when the error
                    occurred and tell us what browser or device you are using.
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;
